/**
 * TCR-1443 — trạng thái hạch toán của fulfillment POS.
 *
 * Hạch toán KHÔNG chạy trong request "Xác nhận khách đã nhận tại chi nhánh":
 * `PosFulfillmentAccountingBridgeListener` (be-tenant) đẩy job sang worker, đặt
 * `pos_fulfillment.accounting_status = 'pending'` rồi trả về ngay. Trước bản này
 * FE chỉ invalidate đúng một lần lúc mutation resolve — lúc đó worker chưa ghi
 * chứng từ nào, nên khối "Chứng từ kế toán" vẫn trống và người dùng phải tự bấm
 * reload mới thấy.
 *
 * Để ở module riêng chứ KHÔNG để trong `useOrderDetail`: nhiều bài test mock cả
 * module hook đó (`vi.mock('@/hooks/useOrderDetail')`), thêm export vào đấy là
 * làm đỏ hàng loạt file không liên quan.
 */

/** Nhịp poll chi tiết đơn trong lúc BE còn đang hạch toán. */
export const POS_ACCOUNTING_POLL_MS = 2_000;

/**
 * Trần thời gian poll. Worker chết hoặc job kẹt trong hàng đợi thì
 * `accounting_status` nằm mãi ở 'pending' — không có trần, tab đang mở sẽ gọi
 * API hai giây một lần cho tới khi người dùng đóng nó.
 */
export const POS_ACCOUNTING_POLL_TIMEOUT_MS = 60_000;

export interface PosAccountingProbe {
  pos_fulfillment?: { accounting_status?: string | null } | null;
}

/** Chỉ 'pending' mới là còn đang chạy; 'posted'/'failed'/'mismatched' đều là kết thúc. */
export function isPosAccountingPending(order: PosAccountingProbe | undefined | null): boolean {
  return order?.pos_fulfillment?.accounting_status === 'pending';
}
